const USER_AUTH_LOCAL_KEY = 'alu_user_auth';
const USER_AUTH_SESSION_KEY = 'alu_user_auth_session';
const USER_LEGACY_TOKEN_KEY = 'alu_token';

const parseJsonSafe = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const getMemberAuthToken = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const localAuth = parseJsonSafe(window.localStorage.getItem(USER_AUTH_LOCAL_KEY));
  if (localAuth?.token) {
    return String(localAuth.token);
  }

  const sessionAuth = parseJsonSafe(window.sessionStorage.getItem(USER_AUTH_SESSION_KEY));
  if (sessionAuth?.token) {
    return String(sessionAuth.token);
  }

  const legacyToken = window.localStorage.getItem(USER_LEGACY_TOKEN_KEY);
  return legacyToken ? String(legacyToken) : null;
};

const decodeJwtPayload = (token) => {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = atob(padded);
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const getMemberAuthUserId = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const token = getMemberAuthToken();
  const payload = decodeJwtPayload(token);
  const candidate = Number(payload?.userId ?? payload?.id ?? null);

  if (Number.isFinite(candidate) && candidate > 0) {
    return candidate;
  }

  // Fallback for sessions where token payload can't be decoded client-side.
  const localAuth = parseJsonSafe(window.localStorage.getItem(USER_AUTH_LOCAL_KEY));
  const sessionAuth = parseJsonSafe(window.sessionStorage.getItem(USER_AUTH_SESSION_KEY));
  const storedUserId = Number(localAuth?.user?.id ?? sessionAuth?.user?.id ?? null);
  if (Number.isFinite(storedUserId) && storedUserId > 0) {
    return storedUserId;
  }

  return null;
};
